module.exports = __webpack_public_path__ + "img/bulb.c935d641.svg";